var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHistory = function SvgHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ABBADB",
    d: "M13.111 3C18.03 3 22 7.028 22 12.02c0 4.692-3.51 8.534-8.018 8.976a.8.8 0 0 1-.871-.8v-.322c0-.41.303-.755.705-.796a6.92 6.92 0 0 0 4.236-2.046 7.12 7.12 0 0 0 2.051-5.013c0-1.88-.728-3.67-2.051-5.013a6.9 6.9 0 0 0-4.941-2.081 6.9 6.9 0 0 0-4.94 2.081 7 7 0 0 0-1.92 3.738h1.96c.68 0 1.042.813.594 1.33l-2.71 3.131a.783.783 0 0 1-1.188 0l-2.709-3.13c-.449-.518-.086-1.331.594-1.331H4.31C4.928 6.357 8.633 3 13.111 3m3.003 10.317h-3.492a.796.796 0 0 1-.79-.802V7.651c0-.442.354-.802.79-.802h.978c.436 0 .79.36.79.802v3.07l1.731.016a.796.796 0 0 1 .784.802v.976a.796.796 0 0 1-.79.802"
  })));
};
export default SvgHistory;